import React, { useCallback, useEffect, useState } from 'react'
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { dateToView } from '../../../../utils/date.utils';
import TableCustom from '../../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import ModalCustom from '../../../../components/modal/ModalCustom';
import AutocompleteSelect from '../../../../components/select/autoCompleteSelect';
import { EmployeeApi } from '../../../../api/employee/employee.api';
import InputTextField from '../../../../components/input/inputTextField';
import { swalError, swalSuccess } from '../../../../components/alert/swal';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function MeetingCoordinator() {
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const { id } = useParams();
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const [form, setForm] = useState<any>()
    const [advisor, setAdvisor] = useState<any[]>([])
    const [open, setOpen] = useState<boolean>(false)
    const [type, setType] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [tab, setTab] = useState<number>(0)
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.NO"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("MEETING.FULL_NAME"),
        },
        {
            id: "leave_type_name",
            width: '350px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.STAFF_ID"),
        },
        {
            id: "leave_type_name",
            width: '250px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("MEETING.JOB_TITLE"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_POSITION.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("MEETING_POSITION.LAST_UPDATED_DATE"),
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_employee, title, first_name, last_name, idcard, position_name, modifier_name, modified_date } =
            objData;

        const objRenderData = {
            key: id_employee,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: `${title} ${first_name} ${last_name}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: idcard || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <RemoveRedEyeOutlined
                            onClick={() => {
                                setForm(objData)
                                setOpen(true)
                                setType('VIEW')
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const getAdvisor = async () => {
        let condition: any = {
            page: 1,
            limit: 100,
        };

        const res = await EmployeeApi.list(condition);
        const data = res.data;
        if (data.status < 300) {
            setAdvisor(data.data.items);
        } else {
            setAdvisor([]);
        }
    }
    useEffect(() => {
        getAdvisor()
    }, [])
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            // if (page) condition = { ...condition, page: page };
            // if (pageLimit) condition = { ...condition, limit: pageLimit };

            const res = await MeetingRoomApi.listCoordinators(condition, id);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    console.log(form);
    const handleSubmit = async () => {
        const body = {
            id_employee: form?.id_employee,
            title: form?.title || "",
            first_name: form?.first_name || form?.fullname?.split(" ")[0],
            last_name: form?.last_name || form?.fullname?.split(" ")[1],
            idcard: form?.idcard || "",
            position_name: form?.position_name,
            department_name_th: form?.department
        }

        await MeetingRoomApi.postCoordinators(body, id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess('เพิ่มผู้ประสานงานการประชุม เรียบร้อยแล้ว')
                loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    return (
        <section className="w-full mt-10">
            
            <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={data?.length}
                rowsData={
                    data.map((data: any, i: any) => {
                        return renderData(data, i);
                    })
                }
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
            />
            <ModalCustom title={type === 'VIEW' ? 'ข้อมูลผู้ประสานงานการประชุม' :'เพิ่มผู้ประสานงานการประชุม'} subTitle={'กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน'} open={open} component={
                <div>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <AutocompleteSelect
                                heading={'ค้นหาชื่อ-นามสกุล หรือ เลขประจำตัวเจ้าหน้าที่'} placeholder={'ค้นหาชื่อ-นามสกุล หรือ เลขประจำตัวเจ้าหน้าที่'}
                                freeSolo
                                labelId={''} options={advisor}
                                getOptionLabel={(option: any) => option?.fullname ? `${option?.fullname}` : `${option?.first_name} ${option?.last_name}`}
                                onChange={(e: any, value: any) => {
                                    setForm(value)
                                }}
                                value={form}
                                disabled={type === 'VIEW'}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                            sx={{
                                alignSelf: "end",
                            }}
                        >

                            <InputTextField
                                heading={'ชื่อ-นามสกุล'}
                                placeholder={''}
                                value={form?.fullname || `${form?.first_name} ${form?.last_name}` || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log(e.target.value);
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled={true}

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={'เลขประจำตัวเจ้าหน้าที่'}
                                placeholder={''}
                                value={form?.idcard || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled={true}

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={'ตำแหน่งงาน'}
                                placeholder={''}
                                value={form?.position_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled={true}

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={6}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={'หน่วยงาน'}
                                placeholder={''}
                                value={form?.department || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }
                                }
                                helperText={
                                    ""
                                }
                                disabled={true}

                            />
                        </Grid>
                    </Grid>
                    <div className='flex justify-center gap-4 mt-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setForm(null)

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        {type !== 'VIEW' &&
                            <ButtonPrimary
                                onClick={() => {
                                    setOpen(false)
                                    handleSubmit()
                                }}
                                mode='add'
                                buttonName={'ยืนยัน'}
                            />}
                    </div>
                </div>
            } />
        </section >
    )
}
